// components/PortalTooltip.tsx
import { createPortal } from 'react-dom';

interface PortalTooltipProps {
  x: number;
  y: number;
  children: React.ReactNode;
}

export function PortalTooltip({ x, y, children }: PortalTooltipProps) {
  const host = document.getElementById('tooltip-root');
  if (!host) return null;

  const style: React.CSSProperties = {
    position: 'fixed',
    top: y,
    left: x,
    transform: 'translate(-50%, -100%)',
    zIndex: 9999,
  };

  return createPortal(
    <div
      style={style}
      className="flex h-fit w-fit max-w-[400px] flex-col gap-2 rounded-md bg-accent-active-primary-40 px-4 py-2 shadow-md"
    >
      {children}
    </div>,
    host
  );
}
